import { CreateUserData } from 'pages/adminPages/createUserForm';
import { AdminUserData } from 'entities/adminUser/model/adminUserModel';
import { axiosApi } from 'app/api/api';

export const adminUsersApi = {
  create: async (data: CreateUserData) => {
    const res = await axiosApi.post<CreateUserData>(`/admin/user`, {
      ...data,
      email: data.email.toLowerCase(),
    });

    return res.data;
  },

  fetch: async () => {
    const res = await axiosApi.get<AdminUserData[]>(`/admin/users`);

    return res.data;
  },

  update: async (userData: AdminUserData) => {
    const res = await axiosApi.put(`/admin/user`, userData);

    return res.data;
  },

  delete: async (id: string) => {
    const res = await axiosApi.delete(`/admin/user`, {
      params: { user_id: id },
    });

    return res.data;
  },
};
